export default [
    {
        path: '/dashboard-general',
        name: 'dashboard-general',
        component: () => import('@/views/dashboard/general/General.vue'),
        meta: {
            title: 'i18n:Inicio',
            resource: 'Publico',
            action: 'ver-publico',
            redirectIfLoggedIn: false,
            redirectIfNoEmpresa: true,
            redirectIfReset: true,
        },
    },
]
